import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HierarchyManagementDimensionsCard = _resolveComponent("HierarchyManagementDimensionsCard")
  const _component_HierarchyManagementHierarchiesCard = _resolveComponent("HierarchyManagementHierarchiesCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_HierarchyManagementDimensionsCard, {
      dimensions: _ctx.dimensions,
      selectedHierarchy: _ctx.selectedHierarchy,
      validityTreeDate: _ctx.validityTreeDate,
      hierarchyType: _ctx.hierarchyType,
      onSynchronized: _ctx.onSynchronized,
      onDimensionSelected: _ctx.setSelectedDimension,
      onLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('loading', $event))),
      onNodeMetadataChanged: _ctx.onNodeMetadataChange,
      onDimensionMetadataChanged: _ctx.onDimensionMetadataChange,
      onValidityDateSelected: _ctx.setValidityDate,
      onMasterHierarchyCreated: _ctx.onMasterHierarchyCreated
    }, null, 8, ["dimensions", "selectedHierarchy", "validityTreeDate", "hierarchyType", "onSynchronized", "onDimensionSelected", "onNodeMetadataChanged", "onDimensionMetadataChanged", "onValidityDateSelected", "onMasterHierarchyCreated"]),
    _createVNode(_component_HierarchyManagementHierarchiesCard, {
      selectedDimension: _ctx.selectedDimension,
      nodeMetadata: _ctx.nodeMetadata,
      validityDate: _ctx.validityDate,
      dimensionMetadata: _ctx.dimensionMetadata,
      synchronizationTrigger: _ctx.synchronizationTrigger,
      reloadHierarchiesTrigger: _ctx.reloadHierarchiesTrigger,
      onLoading: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('loading', $event))),
      onHierarchyTypeSelected: _ctx.onHierarchyTypeSelected,
      onHierarchySelected: _ctx.onHierarchySelected,
      onDateSelected: _ctx.onValidityTreeDateSelected
    }, null, 8, ["selectedDimension", "nodeMetadata", "validityDate", "dimensionMetadata", "synchronizationTrigger", "reloadHierarchiesTrigger", "onHierarchyTypeSelected", "onHierarchySelected", "onDateSelected"])
  ]))
}